<template>
  <NuxtLoadingIndicator
    :throttle="0"
    :height="2"
    color="#5258fb"
  />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
